export default __webpack_public_path__ + "static/media/DINPro-Medium.63fd2c1a.ttf";